import { SERVICE_URL } from './ServiceURL'

class OperadorasService {

	constructor (resource) {
		this.store = resource.$store;
		this.http = resource.$http;
	}

	fetch () {
		return new Promise((resolve, reject) => {
			this.http.get(`${SERVICE_URL}v1/operadoras/`, {
				headers: {
					'x-access-token': this.store.state.user.token || ''
				}
			})
				.then(response => response.json())
				.then(refuses => resolve(refuses))
				.catch(err => {
					reject(err.body.message || err.message);
				})
		});
	}
}
export default OperadorasService;


// WEBPACK FOOTER //
// ./src/service/OperadorasService.js